import classNames from 'classnames'
import { MySingleInputDateField } from 'components/MySingleInputDateField'
import { parse } from 'date-fns'
import { useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

type MyDateRangeProps = {
  className?: string
  label: string
  hint?: string
  name: string
  startLabel?: string
  endLabel?: string
  startFromYear?: number
  endFromYear?: number
  startToDate?: Date
  endToDate?: Date
}
export const MyDateRange = (props: MyDateRangeProps) => {
  const { className, hint, label, name } = props
  const {
    startLabel,
    startFromYear,
    endLabel,
    endFromYear,
    startToDate,
    endToDate
  } = props

  const wrapperClasses = classNames(
    ['my-date-range', 'ds-u-border--0', 'ds-u-margin--0', 'ds-u-padding--0'],
    className
  )
  const fieldWrapperClasses = classNames('my-date-range__field-wrapper', [
    'ds-u-md-display--flex',
    'my-u-gap-x--6'
  ])

  const { control, formState, watch } = useFormContext()
  const [endFromDate, setEndFromDate] = useState<Date | undefined>()

  const watchStartDate = watch(`${name}.start`)

  // Ensure end date is after selected start date
  useEffect(() => {
    if (watchStartDate) {
      setEndFromDate(parse(watchStartDate, 'MM/dd/yyyy', new Date()))
    }
  }, [watchStartDate])

  return (
    <fieldset className={wrapperClasses}>
      <legend className="ds-u-border--0">
        <div className="ds-c-label">
          <span>{label}</span>
          {hint && <span className="ds-c-field__hint">{hint}</span>}
        </div>
      </legend>
      <div className={fieldWrapperClasses}>
        <Controller
          control={control}
          name={`${name}.start`}
          render={({ field: { name: fieldName, onChange, value } }) => (
            <MySingleInputDateField
              id={`${name}_start`}
              className="my-c-mydaterange-field"
              name={fieldName}
              label={startLabel || 'From'}
              labelClassName="ds-u-margin-top--1"
              hideLabelMask
              onChange={onChange}
              value={value}
              fromYear={startFromYear}
              toDate={startToDate}
              errorMessage={formState.errors?.[name]?.start?.message}
              errorPlacement="bottom"
            />
          )}
        />

        <Controller
          control={control}
          name={`${name}.end`}
          render={({ field: { name: fieldName, onChange, value } }) => (
            <MySingleInputDateField
              id={`${name}_end`}
              className="my-c-mydaterange-field"
              name={fieldName}
              label={endLabel || 'To'}
              labelClassName="ds-u-margin-top--1"
              hideLabelMask
              onChange={onChange}
              value={value}
              fromYear={endFromDate ? undefined : endFromYear}
              fromDate={endFromDate}
              toDate={endToDate}
              errorMessage={formState.errors?.[name]?.end?.message}
              errorPlacement="bottom"
            />
          )}
        />
      </div>
    </fieldset>
  )
}
